import {PatientSurveyProps} from '../../types';
import {getRatingRange} from '../helpers/getRatingRange';
import {parseJSON} from '../../../../helpers';
import RadioFieldGroup from '../../../common/formik/fields/RadioGroupField';

type RatingFieldProps = {
  data: PatientSurveyProps;
  disabled: boolean;
}

const RatingField = ({data, disabled}: RatingFieldProps) => {
  const {details, label} = data;
  const parsedDetails = parseJSON(details);
  const ratings = getRatingRange(parsedDetails);

  return (
    <div className="rating">
      <div className="rating-header">
        <div className="rating-label">{label}</div>
        <div className="rating-values">
          {ratings.map((item) => {
            return (
              <div className="rating-value" key={item}>{item}</div>
            );
          })}
        </div>

      </div>
      {data.children?.map((elem) =>
        (
          <RadioFieldGroup
            name={elem.id.toString()}
            data={ratings}
            label={elem.label}
            key={elem.id}
            required={elem.required}
            disabled={disabled}
            defaultValue={elem.answer || ''}
            showLabel={false}
          />
        )
      )}
    </div>
  );
};

export default RatingField;
